import { requestV2 } from './request'
import { findRegionByLocale } from '@/common/region-locale'

// #region 所有配备件
// 配件项的基本信息
export interface PartSimpleInfo {
  partId: string
  name: string
  imageUrl: string
  desc: string
  categoryTagName: string
  imageUrlList: string[]
}

// 配件分类
export interface PartCategory {
  name: string
  partSimpleInfo: PartSimpleInfo[]
}

// 产品配件信息
export interface ProductPart {
  title: string
  productCode: string
  category: PartCategory[]
}

// 配件 API 响应
export interface AccessoriesResponse {
  productPart: ProductPart[]
  title: string
  desc: string
}

// 所有配备件
export async function getAllAccessories(locale?: string): Promise<AccessoriesResponse> {
  const params: any = {}
  if (locale) {
    params.region = findRegionByLocale(locale)
  }
  const res = await requestV2('/part/list', params)
  return res
}

getAllAccessories.swrkey = (locale: string) => `/${locale}/api/front/v2/part/list`
// #endregion

// #region 配件详情
// 配件详情内容
export interface AccessoryContent {
  title: string
  desc: string
}

// 配件相关产品
export interface AccessoryProduct {
  title: string
  mediaUrl: string
  jumpUrl: string
}

// 配件详情响应
export interface AccessoryDetailsResponse {
  partId: string
  name: string
  imageUrl: string
  mediaUrlList: string[]
  content: AccessoryContent[]
  products: AccessoryProduct[]
  categoryName: string
}
// 配备件详情
export async function getAccessoryDetails(part_id: string): Promise<AccessoryDetailsResponse> {
  const res = await requestV2('/part/info', { part_id })
  return res
}

getAccessoryDetails.swrkey = (part_id: string) => `/api/front/v2/part/info/${part_id}`

// #endregion

// #region 指定产品——配备件列表
// 指定产品配件列表响应
export interface ProductAccessoryListResponse {
  list: PartSimpleInfo[]
}

export async function getProductAccessoryList(product_doc_path_code: string): Promise<ProductAccessoryListResponse> {
  const res = await requestV2('/part/product/list', { product_doc_path_code })
  return res
}

getProductAccessoryList.swrkey = (product_doc_path_code: string) =>
  `/api/front/v2/part/product/list/${product_doc_path_code}`
// #endregion
